/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function CareerIcon({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon-career">
        <g id="Group 59 Copy 3">
          <g id="icon-legal and finance copy">
            <g id="Group 58 Copy 2">
              <g id="icon-journey-course">
                <circle
                  id="Oval"
                  cx="78.5"
                  cy="78.5"
                  r="77.5"
                  fill={mainColor}
                  stroke="white"
                  stroke-width="2"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="success copy">
          <path
            id="Path"
            d="M108.228 59.7317H97.8437V51.671H114.613C114.614 51.6704 114.615 51.6704 114.616 51.671C115.933 51.671 117 50.5949 117 49.2686C117 48.5673 116.702 47.9366 116.227 47.4974L111.6 42.8352L116.298 38.101C116.98 37.4141 117.184 36.3812 116.816 35.4828C116.446 34.5856 115.577 34 114.613 34H95.4595C94.1431 34 93.0752 35.0755 93.0752 36.4024V59.7317H90.3519C85.5168 59.7317 81.5834 63.6951 81.5834 68.5669V113.598C81.5834 114.925 82.6513 116 83.9677 116H114.613C115.93 116 116.997 114.925 116.997 113.598V68.5675C116.997 63.6957 113.063 59.7317 108.228 59.7317Z"
            fill={secondaryColor}
          />
          <path
            id="Path_2"
            d="M32 106.629V113.452C32 114.859 33.194 116 34.6671 116H43.8056V97.2571H41.8087C36.4001 97.2571 32 101.461 32 106.629Z"
            fill={secondaryColor}
          />
          <path
            id="Path_3"
            d="M48.5278 94.3546V113.604C48.5278 114.927 49.7217 116 51.1948 116H60.3334V85.5428H58.3359C52.9277 85.5428 48.5278 89.496 48.5278 94.3546Z"
            fill={secondaryColor}
          />
          <path
            id="Path_4"
            d="M65.0555 82.4132V113.666C65.0555 114.955 66.2495 116 67.722 116H76.8611V73.8286H74.8642C69.4556 73.8286 65.0555 77.6796 65.0555 82.4132Z"
            fill={secondaryColor}
          />
        </g>
      </g>
    </svg>
  );
}

CareerIcon.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
CareerIcon.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(CareerIcon);
memoized.displayName = 'TaskIcon';
export default memoized;
